import React, { useState } from 'react'
import { getIssues, Issues } from 'utils/IssuesUtil';
import { useAppContext } from 'hooks/useAppContext';
import Grid from './Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import {
  Redirect,
} from "react-router-dom";

const CompletedIssuesGrid = () => {
  const columns = Issues.columns
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Resolved Issues"
  const getFormPath = () => import('components/Shared/SkeletonForm')
  const enable = { "delete": false, "edit": false }
  const [details, setDetails] = useState(false)
  const [issueID, setIssueID] = useState("")
  // const [issue, setIssue] = useState({})

  const issuesDetails = (data) => {
    console.log(data)
    setIssueID(data.IssueId)
    // setIssue(data)
    setDetails(true)
  }
  const selection = { "display": true, "callback": issuesDetails, "btnText": "Details", "status": "Closed" }
  return (
    <div style={{ padding: '10px' }}>
      {
        details && <Redirect to={`/projects/${selectedProject}/Issues/${issueID}`} />
      }
      {
        selectedProject ?
          <Grid columns={columns} title={title} getRecords={getIssues} selectedProject={selectedProject} component="Issues" formPath={getFormPath} enable={enable} selection={selection}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 15, 25]
            }}
          /> : <SkeletonGrid title={title} />
      }
    </div>
  )
}

export default CompletedIssuesGrid